import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getTechnicianHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "technicians", ...action.payload }),
		);
		yield put({
			type: types.GET_TECHNICIAN_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_TECHNICIAN_ERROR,
			payload,
		});
	}
}

export function* getTechnicianWatcherSaga() {
	yield takeLatest(types.GET_TECHNICIAN_START, getTechnicianHandlerSaga);
}

//create

//delete

function* deleteTechnicianHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("technicians", action.payload),
		);
		yield put({
			type: types.DELETE_TECHNICIAN_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_TECHNICIAN_ERROR,
			payload,
		});
	}
}

export function* deleteTechnicianWatcherSaga() {
	yield takeLatest(
		types.DELETE_TECHNICIAN_START,
		deleteTechnicianHandlerSaga,
	);
}

//update
